function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#636E95"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.167 2.333C14.522 2.333 14 2.856 14 3.5v9.333c0 .645.522 1.167 1.167 1.167H24.5c.644 0 1.167-.522 1.167-1.167 0-5.799-4.701-10.5-10.5-10.5zm1.166 9.334V4.748c3.586.517 6.402 3.333 6.919 6.919h-6.919z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.29 16.403c-.607-.217-1.274.1-1.491.706l-.002.006c-1.72 4.86-7.052 7.405-11.912 5.686-4.86-1.719-7.405-7.052-5.686-11.911.94-2.657 3.03-4.747 5.686-5.687.609-.212.93-.878.717-1.487-.212-.61-.878-.93-1.487-.718C4.04 5.145.855 11.81 3.001 17.885c2.146 6.075 8.811 9.26 14.887 7.114 3.324-1.174 5.94-3.79 7.114-7.114.21-.606-.108-1.267-.712-1.482z"
}));

var SvgPieChartOutline = function SvgPieChartOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPieChartOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie-chart-outline.2212e1d5.svg";
export { ForwardRef as ReactComponent };